import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {rolesDar} from 'app/dar/common/services/roles/roles-dar';
import {ManageRoleService} from '@Services/gestion-universite/roles/manage-roles.service';
import {Individu} from '@Services/index';
import {Pagination} from '@Common/widgets/general/pagination';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {Recrute} from 'app/dar/common/services';
import {RecruteFormModel} from 'app/dar/dossier/common/recrute/recrute-form.model';
import {SubSink} from '@Common/core/utils/subsink';

/**
 * Ajout de l'INM recrutement
 * Ajout du recruté et du gestionnaire SPTA le cas échéant
 */
@Component({
  selector: 'app-recrute',
  templateUrl: './recrute.component.html',
  styleUrls: ['./recrute.component.scss']
})
export class RecruteComponent implements OnInit, OnChanges, OnDestroy {
  @Input() recrute: RecruteFormModel = null;

  @Input() displayGestSPTA = false;

  /**
   * Emission lors du changement du formulaire (tous controls)
   */
  @Output() onRecruted: EventEmitter<any> = new EventEmitter<any>();

  recruteFormGroup: UntypedFormGroup;
  gestSPTA: Individu[] = [];
  subSink = new SubSink();

  constructor(private manageRoleService: ManageRoleService,
              public formBuilder: UntypedFormBuilder) {

  }

  ngOnInit() {
    this._initRecruteFormGroup();
    this._initRecruteFormGroupValueChanges();
    if (this.displayGestSPTA) {
      this._listSPTAGestionnaires();
    }
  }
  private _initRecruteFormGroup() {
    const _inmRecrutement = this.recrute?.hasINMRecrutement ? ['', Validators.required] : [''];
    this.recruteFormGroup = this.formBuilder.group({
      id: [''],
      first_name: ['', Validators.maxLength(80)],
      last_name: ['', Validators.maxLength(80)],
      gestionnaire: [''],
      inm_recrutement: _inmRecrutement
    });
  }
  private _initRecruteFormGroupValueChanges() {
    this.subSink.sink = this.recruteFormGroup.valueChanges
      .pipe(debounceTime(250), distinctUntilChanged())
      .subscribe((_data) => {
        const dataToEmit = <RecruteFormModel>{
          recrute: <Recrute>{
            id: this.recrute && this.recrute.recrute ? this.recrute.recrute.id : null,
            first_name: _data.first_name,
            last_name: _data.last_name,
          },
          gestionnaire: _data.gestionnaire,
          INMRecrutement: _data.inm_recrutement || null
        };
        this.onRecruted.emit(dataToEmit);
      });
    if (this.recrute) {
      this.onRecruted.emit(this.recrute);
    }
  }

  private _setValuesForm(recrute: RecruteFormModel) {
    if (!this.recruteFormGroup) {
      this._initRecruteFormGroup();
      this._initRecruteFormGroupValueChanges();
    }
    this.recruteFormGroup.patchValue({id: recrute && recrute.recrute && recrute.recrute.id ? this.recrute.recrute.id : null});
    this.recruteFormGroup.patchValue({first_name: recrute && recrute.recrute && recrute.recrute.first_name ? recrute.recrute.first_name : ''});
    this.recruteFormGroup.patchValue({last_name: recrute && recrute.recrute && recrute.recrute.last_name ? recrute.recrute.last_name : ''});
    this.recruteFormGroup.patchValue({gestionnaire: recrute && recrute.gestionnaire ? recrute.gestionnaire : ''});
    this.recruteFormGroup.patchValue({inm_recrutement: recrute.INMRecrutement});
  }

  private _listSPTAGestionnaires() {
    const urlQS = new Map<string, any>();
    urlQS.set('role', rolesDar.spta_traitement).set('entite', 'dar');

    this.subSink.sink = this.manageRoleService.listAllItems(urlQS)
      .subscribe((roles: Pagination) => {
        const gest: Individu[] = [];
        const first: Individu = <Individu>{uid: null, first_name: '', last_name: ''};
        if (roles && roles.list.length > 0) {
          roles.list.forEach((_role) => gest.push(_role.individu));
        }
        gest.sort((a: Individu, b: Individu) =>  (a.last_name > b.last_name) ? 1 : ((b.last_name > a.last_name) ? -1 : 0));
        this.gestSPTA = [first, ...gest];
      });
  }

  onSelectSPTA($event) {
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.recrute && changes.recrute.currentValue !== null) {
      this._setValuesForm(changes.recrute.currentValue);
    }
  }
}
